// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1stp4","uploadedContainer":"styles_uploadedContainer__2HfcS","button":"styles_button__1A3fc"};